import React from 'react';
import { Badge } from 'react-bootstrap';
import { formatDate } from '../../utils/format';

// A finished deploy is "Deployed" on either environment; "Live" is kept for production only.
const DEPLOY_BADGES = {
  DEPLOYED: { bg: 'success', label: 'Deployed' },
  PENDING: { bg: 'warning', label: 'Queued' },
  DEPLOYING: { bg: 'warning', label: 'Deploying' },
  DEPLOY_FAILED: { bg: 'danger', label: 'Failed' },
  UNKNOWN: { bg: 'secondary', label: 'Unknown' },
  NOT_TRACKED: { bg: 'secondary', label: 'Not tracked' },
};

export const DeployBadge = ({ deploy }) => {
  if (!deploy) {
    return <Badge bg="secondary">No deploys yet</Badge>;
  }
  const { bg, label } = DEPLOY_BADGES[deploy.status] || DEPLOY_BADGES.UNKNOWN;
  return (
    <Badge bg={bg} title={deploy.detail || undefined}>
      {label}
    </Badge>
  );
};

export const shortSha = (sha) => (sha ? sha.slice(0, 7) : '');

export const firstLine = (message) => (message || '').split('\n')[0];

export const timeAgo = (iso) => {
  if (!iso) return '';
  const seconds = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (seconds < 60) return 'just now';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} h ago`;
  return formatDate(iso);
};

/**
 * Plain text of an HTML fragment, for showing edits as readable before/after text. Parsed with
 * DOMParser (an inert document: no scripts run and no images load), never innerHTML on a live
 * element, because page content must not execute in the admin app.
 */
export const htmlToText = (html) => {
  const doc = new DOMParser().parseFromString((html || '').replace(/<br\s*\/?>/gi, ' '), 'text/html');
  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
};

export const truncate = (text, max = 120) => (text.length > max ? `${text.slice(0, max - 1)}…` : text);
